import { ActivityTypeEnum } from 'enums';

const activityTypeMap: Record<ActivityTypeEnum, string> = {
  [ActivityTypeEnum.ALL_YEAR]: 'All year',
  [ActivityTypeEnum.BLOCK]: 'Block booking',
  [ActivityTypeEnum.HOLIDAYS_ONLY]: 'Holidays only',
  [ActivityTypeEnum.ONE_OFF]: 'Single session',
  [ActivityTypeEnum.TERM_TIME]: 'Term time',
  [ActivityTypeEnum.ONE_OFF_AND_BLOCK]: 'Block and Single',
  [ActivityTypeEnum.SUBSCRIPTION]: 'Monthly subscription',
};

export const getActivityType = (activityType: ActivityTypeEnum): string => {
  return activityTypeMap[activityType];
};
